import axios from 'axios';
import WebEnvConfig from '@/models/WebEnvConfig';
import URLUtils from '@/utils/URLUtils';

export default class TheWebEnvConfigService {
    private static instance: TheWebEnvConfigService;
    private configs: WebEnvConfig[] = [];

    private constructor() {
        //const noEmptyFunction = true;
    }

    public static getInstance(): TheWebEnvConfigService {
        if (!this.instance) {
            this.instance = new TheWebEnvConfigService();
        }
        return this.instance;
    }

    async getConfig(): Promise<WebEnvConfig[]> {
        if (!this.haveConfig()) {
            this.configs = await this.getConfigFromFile();
        }
        return this.configs as WebEnvConfig[];
    }

    async refreshConfig(): Promise<void> {
        this.configs = await this.getConfigFromFile();
    }

    async getConfigByHost(hostname?: string): Promise<WebEnvConfig> {
        if (!hostname) {
            const currentUrl = URLUtils.parseURL(URLUtils.getURL() || '');
            if (currentUrl) {
                hostname = (currentUrl as URL).hostname;
            }
        }

        const configs = await this.getConfig();
        for (const key in configs) {
            const config = configs[key];
            if (config.hostname?.toLowerCase() === hostname?.toLowerCase()) {
                return config;
            }
        }
        return {};
    }

    private haveConfig() {
        return this.configs && this.configs.length > 0;
    }

    private async getConfigFromFile(): Promise<WebEnvConfig[]> {
        const fileData = await await axios.get<any>('/web.env.config.json', {});
        return fileData.data;
    }
}
